import React from 'react';
import '../../css/ProgressBar.css';

/**
 * ProgressBar — unified determinate / indeterminate progress.
 *
 * Props:
 *   value / max  — determinate progress (omit value for indeterminate)
 *   variant      — 'accent' (default) | 'success' | 'warning' | 'danger'
 *   label        — optional left caption
 *   showPercent  — show "n%" on the right (determinate only)
 */
const ProgressBar = ({ value, max = 100, variant = 'accent', label, showPercent = false, className = '' }) => {
    const indeterminate = value == null || Number.isNaN(value);
    const pct = indeterminate ? 0 : Math.max(0, Math.min(100, (value / max) * 100));
    const fillVariant = variant === 'accent' ? '' : `qd-progress-fill--${variant}`;

    return (
        <div className={`qd-progress ${indeterminate ? 'qd-progress--indeterminate' : ''} ${className}`.trim()}>
            {(label || showPercent) && (
                <div className="qd-progress-head">
                    {label && <span>{label}</span>}
                    {showPercent && !indeterminate && <span>{Math.round(pct)}%</span>}
                </div>
            )}
            <div
                className="qd-progress-track"
                role="progressbar"
                aria-valuenow={indeterminate ? undefined : Math.round(pct)}
                aria-valuemin={0}
                aria-valuemax={100}
            >
                <div
                    className={`qd-progress-fill ${fillVariant}`.trim()}
                    style={{ width: indeterminate ? undefined : `${pct}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
